// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import OutlinedPopover from '../ui/OutlinedPopover';
// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import * as accountActions from '../account/actions';
import * as coreSelectors from '../core/selectors';
import * as serviceSelectors from './selectors';
import * as accountSelectors from '../account/selectors';
import * as serviceActions from './actions';
import 'react-intl-tel-input/dist/main.css';
import VipIcon from '@material-ui/icons/Beenhere';

import * as Formatters from '../ui/Formatters';
import PhoneTextFieldWithFlag from '../ui/PhoneTextFieldWithFlag';
import AccountSelect from '../account/AccountSelect';

// Get an instance of `PhoneNumberUtil`.
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
// Require `PhoneNumberFormat`.
const PNF = require('google-libphonenumber').PhoneNumberFormat;

const styles = theme => ({
    /* Raised box around the content */
    contentBox : {
      width: '100%',
      height: '100%',
      borderRadius: 20,
      padding: 0,
      display: 'flex',
    },
    
    /* Scrolled area inset from the content box */
    contentScroller : {
      overflow: 'auto',
      width: '100%',
    },
  
    /* Top control area with search box and add content */
    controlPanel : {
      display: 'flex',    
      alignItems: 'center',
    },
  
    /* Search input in the control panel */
    searchInput : {
      fontSize: 12,
      height: 30,
    },
    
  
    /* Contact list container */
    contactList : {
      marginRight: 20,
    },
  
    /* Contact row */
    contactRow: {
      display: 'flex',
      marginRight: 30,
    },
  
    /* Left side icon */
    peopleIcon : {
      marginLeft: 20,
      display: 'flex',
      alignItems: 'center',
    },
  
    /* Clickable center area with contact name */
    infoBlock : {
      flexGrow: '1',
      paddingLeft: 10,
      '&:hover' : {
        background: theme.palette.grey[200],
      },
    },
  
    /* Top name line in the info block */
    name: {
      ...theme.typography.body1,
      fontWeight: 'bold',
    },
    /* Bottom business name line in the info block */
    business: {
      ...theme.typography.body1,
      color: theme.palette.primary.main,
    },
    
  
    /* Right side menu */
    menuBlock : {
      display: 'flex',
      alignItems: 'center',
    },
  
    /* Section row at the start of each letter */
    sectionRow: {
      marginLeft: 20,
      marginRight: 20,
      marginTop: 20,   
      ...theme.typography.body2,
      fontWeight: 'bold',
    },
  
    oddRow: {
      
    },
  
    evenRow: {
      backgroundColor: '#fcf9f2',
  
    },
    tableHeader:{
      backgroundColor:'#a9a1b6'
    },
    tableHeaderCell:{
      color:'white',
      fontFamily:'Sofia-bold',
      backgroundColor:'#a9a1b6'
    }
  });

class VipContacts extends Component {

    state = {
        vipContactRecord: {},
        openDialog: false,
        showAddPopup: false,
        accountId: '',
        showDeletePopup: false,
        phoneNumber: "",
        phoneValidation:false,
        confirmDelete: false,
        fullNumber: "",
        showError: false,
        contactDetails: {},
        vipCallerId: null
    }

    changeContactDetails = (key, value) => {
        this.setState({contactDetails: {...this.state.contactDetails, [key]: value}});
    }

    numberClicked = (record, operation) => {
        if (operation === 'delete') {
            this.setState({ confirmDelete: true, phoneNumber: record })
        }
    }
    handleSelectFlag =  (value, countryData, number,status) => {
        //console.log("HandleSelectFlag --- ","phonevalidation:",value,"country data :", countryData,"number:", number, status," current full number:", this.state.fullNumber)

        if(countryData && countryData.dialCode){
            this.setState({ phoneNumber : number,countryData:countryData,phoneValidation:status});
          }   
    }

    formatPhoneNumber = (inputPhone) => {
        try{
            var tel = phoneUtil.parseAndKeepRawInput(inputPhone);
            //console.log(tel,"Raw Input",phoneUtil);
           if(phoneUtil.isValidNumber(tel)){
            return phoneUtil.format(tel,PNF.NATIONAL); 
           }
          }catch(exception){
            return inputPhone;
          }
    }
    getDefaultCountry = (phoneNumber) => {
        var phone = "+" + phoneNumber.replace(/[^0-9]/g, '');
        try{
            var tel = phoneUtil.parse(phone);
        } catch(error){ 
            return "gb";
        }
        if(phoneUtil.getRegionCodeForNumber(tel)){
            return phoneUtil.getRegionCodeForNumber(tel).toLowerCase();
        }
        return "";
    }

    deleteNumber = (record, completed) => {
        this.props.unblockPhoneNumber(record.accountId, record.phoneNumber, completed)
        this.setState({ showDeletePopup: false,phoneNumber:'' })
    }

    handlePhoneChange = (event) => {
        this.setState({ phoneNumber: event.target.value });
    }

    handleIntlPhoneChange = (status, value, countryData, number, id) => {
        //console.log("handlePhoneChange",status, value, countryData, number, id)
        this.setState({ phoneNumber: value, countryData: countryData, phoneValidation: status, fullNumber: number, showError: false });
    }

    handleBlur = (status, newValue, countryData, number, id) => {
        console.log("handleBlur",status,"number ::",number,"::countryData::",countryData);
        if(status){
          if(this.state.countryData && this.state.countryData.dialCode){
            try{
                var phone = "+"+number.replace(/[^0-9]/g, '');
                var formattedNumber = this.formatPhoneNumber(phone);
                this.setState({countryData:countryData,phoneNumber:formattedNumber})
            }catch(exception){

            }
          }
        }else{
           // this.props.onChange(number,this.state.countryData);
            this.setState({phoneValidation:status})
          }

      }

    saveNumber = (record, completed) => {
        var phone = this.state.phoneNumber;
        if(this.state.phoneNumber){
            phone = "+" + phone.replace(/[^0-9]/g, '');
        }
        try{
            var tel = phoneUtil.parseAndKeepRawInput(phone);
            console.log(tel,"Raw Input",phoneUtil);
           if(phoneUtil.isValidNumber(tel)){
            if(this.props.vipContactsList.filter(contact => contact.phoneNumber === phone && this.state.vipCallerId === null).length === 0){
                if(this.state.vipCallerId !== null){
                    this.props.updateVipContact(this.state.vipCallerId, this.props.accountId, this.state.contactDetails.name, 
                        this.state.contactDetails.company, phone, completed)
                } else {
                    this.props.createVipContact(this.props.accountId,this.state.contactDetails.name, 
                        this.state.contactDetails.company, phone, completed)
                }
                this.setState({ showAddPopup: false,phoneNumber:"", contactDetails: {}, vipCallerId: null })
            }else{
                this.setState({showError: true});
            }
           }else{
            console.log("cannot save the number");
           }
          }catch(exception){
              console.log("cannot save the number");
            return;
          }
   
    }



    render() {

        const {
            classes,
            vipContactsList,
            deleteVipContact
        } = this.props;

        return(
            <React.Fragment>
                <OutlinedPopover open={this.state.showAddPopup}
                    icon={<VipIcon color='primary' fontSize='large' />}
                    title={this.state.vipCallerId === null ? "Add VIP Contact" : "Edit VIP Contact"}
                    onClose={() => this.setState({ showAddPopup: false,phoneNumber:'',contactDetails: {}, vipCallerId: null })}>

                    <MuiCore.Grid container>
                    <MuiCore.Grid xs={12} style={{marginTop: '10px'}}>
                            <MuiCore.TextField
                                fullWidth
                                variant='outlined'
                                autoFocus={true}
                                onChange={(event) => {
                                    if(event.target.value?.length < 70){
                                        this.changeContactDetails('name', event.target.value)
                                    }
                                }}
                                label='Name'
                                
                                InputLabelProps={{ shrink: true }}            
                                value={this.state.contactDetails.name || ''}/>
                        </MuiCore.Grid>
                        <MuiCore.Grid xs={12} style={{marginTop: '10px'}}>
                            <MuiCore.TextField
                                fullWidth
                                variant='outlined'
                                autoFocus={true}
                                onChange={(event) => {
                                    if(event.target.value?.length < 70){
                                        this.changeContactDetails('company', event.target.value)
                                    }
                                }}
                                label='Company'
                                InputLabelProps={{ shrink: true }}            
                                value={this.state.contactDetails.company || ''}/>
                        </MuiCore.Grid>
                        <MuiCore.Grid item xs={12} style={{marginTop:'10px'}}>
                            <MuiCore.FormControl fullWidth>
                                {/* <MuiCore.InputLabel>Phone Number</MuiCore.InputLabel> */}
                                {/* <IntlTelInput containerClassName="intl-tel-input" style={{marginTop:'14px'}}
                                    onlyCountries={['gb', 'de', 'fr', 'it', 'es', 'ie', 'pl', 'dk', 'se', 'no', 'us','nl']}
                                    preferredCountries={['gb']}
                                    inputClassName="MuiInputBase-input" defaultCountry={this.getDefaultCountry(this.state.phoneNumber)} value={this.state.phoneNumber} onPhoneNumberChange={this.handleIntlPhoneChange} onPhoneNumberBlur={this.handleBlur} onSelectFlag={this.handleSelectFlag} />  */}
                                <PhoneTextFieldWithFlag variant='standard' value={this.state.phoneNumber} onPhoneNumberChange={(change) => {
                                    this.setState({phoneNumber: change});
                                }} isValid={(valid) => this.setState({phoneValidation: valid})}/>


                            </MuiCore.FormControl>
                            {this.state.showError && this.state.phoneNumber.length >= 10 && <MuiCore.Typography variant='body1' style={{fontSize: 15, color: 'red', marginTop: 5}}>
                                This phone number has already been added as a VIP Contact.
                            </MuiCore.Typography>}
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                    
                    <MuiCore.DialogActions style={{ paddingLeft: 20, paddingRight: 20 }}>
                        <MuiCore.Button onClick={this.saveNumber} disabled={!this.state.phoneValidation}>
                            {this.state.vipCallerId === null ? 'Add' : 'Save'}
                        </MuiCore.Button>
                        <MuiCore.Button onClick={() => this.setState({ showAddPopup: false,phoneNumber:'' })}>
                            Cancel
                        </MuiCore.Button>
                    </MuiCore.DialogActions>
                </OutlinedPopover>
                <MuiCore.Grid item lg={12} md={12}>
                    <MuiCore.Grid lg={6} style={{alignSelf: 'center', marginLeft: 20}}>
                        <MuiCore.Grid container spacing={2}>
                            <AccountSelect accountChanged={(accountId) => {
                                this.props.getVipCallersByAccount(accountId);
                            }}/>
                        </MuiCore.Grid>
                    </MuiCore.Grid>
                </MuiCore.Grid>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <div style={{flexGrow: 1}}>
                    </div>
                    <MuiCore.IconButton onClick={() => this.setState({showAddPopup: true})} style={{marginRight:20}}>
                        <AddIcon fontSize='small' style={{color: '#7F2062', marginRight: 5}}/>
                        <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 14, color: '#09122B'}}>Add VIP Contact</MuiCore.Typography>
                    </MuiCore.IconButton>
                </div>
                <MuiCore.Grid style={{marginRight: 30}}>
                    <MuiCore.TableContainer component={MuiCore.Paper}>
                        <MuiCore.Table sx={{minWidth: 700}}>
                        <MuiCore.TableHead>
                            <MuiCore.TableRow className={classes.tableHeader}>
                            <MuiCore.TableCell style={{color: '#FFF'}}>Name</MuiCore.TableCell>
                            <MuiCore.TableCell style={{color: '#FFF'}}>Company</MuiCore.TableCell>
                            <MuiCore.TableCell style={{color: '#FFF'}}>Phone</MuiCore.TableCell>
                            <MuiCore.TableCell align='right'></MuiCore.TableCell>
                            </MuiCore.TableRow>
                        </MuiCore.TableHead>
                        <MuiCore.TableBody>
                            {vipContactsList.map((contact, index) => {

                            return(
                                <MuiCore.TableRow 
                                key={contact.vipCallerId}
                                hover
                                className={index%2 === 0 ? classes.evenRow : classes.oddRow}
                                onClick={() => {
                                    this.setState({
                                        contactDetails: {
                                            name: contact.name,
                                            company: contact.company
                                        },
                                        phoneNumber: contact.phoneNumber,
                                        vipCallerId: contact.vipCallerId,
                                        showAddPopup: true
                                    })
                                }}
                                >
                                <MuiCore.TableCell component="th" scope="row">{contact.name}</MuiCore.TableCell>
                                <MuiCore.TableCell>{contact.company}</MuiCore.TableCell>
                                <MuiCore.TableCell>{Formatters.formatPhoneNumber(contact.phoneNumber)}</MuiCore.TableCell>
                                <MuiCore.TableCell align='right'>
                                    <div className={classes.menuBlock}>
                                    <MuiCore.IconButton
                                        size='small'
                                        onClick={(event) => {
                                            deleteVipContact(this.props.accountId, contact.vipCallerId)
                                            event.stopPropagation();
                                        }}>
                                        <DeleteIcon/>
                                    </MuiCore.IconButton>
                                    </div>
                                </MuiCore.TableCell>
                                </MuiCore.TableRow>
                            )})}
                        </MuiCore.TableBody>
                        </MuiCore.Table>
                    </MuiCore.TableContainer>
                </MuiCore.Grid>
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return ({
        accountId: accountSelectors.getAccountId(state),
        user: coreSelectors.getUser(state),
        vipContactsList:serviceSelectors.getVipCallers(state)
    });
}

const mapDispatchToProps = {
    setAccountId: accountActions.setAccountId,
    queryAccount: accountActions.queryAccount,
    getVipCallersByAccount:serviceActions.getVipCallersByAccount,
    createVipContact: serviceActions.createVipContact,
    deleteVipContact: serviceActions.deleteVipContact,
    updateVipContact: serviceActions.updateVipContact,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(VipContacts));